import React from 'react'
import { APP_NAME } from 'configs/AppConfig';

export default function Footer() {
	return (
		<footer className="footer">
			<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}&copy;</span> All rights reserved.</span>
			<span>
				<a href="https://status.tunimobile.com" target="_blank" rel="noopener noreferrer">Status Page</a>
			</span>
		</footer>
	)
}

